<div class="container-fluid" *ngIf="isButtonVisible">
  <span style="color: white;">Popup blocked, please click &nbsp;</span> <button type="button" class="btn btn-primary"  (click)="signOut()">Sign out</button>
</div>
